import React from "react";
import { useTranslation } from 'react-i18next';
import Fade from "react-reveal";

const About = () => {
  const { t } = useTranslation();

  return (
    <section id="about">
      <Fade duration={1000}>
        <div className="row">
        <div className="six columns">
              <img
                className="profile-pic"
                src="images/screenshots/homescreen.png"
                alt="Nordic Giant Profile Pic"
              />
            </div>
          <div className="six columns main-col">
            <h2>{t('about.title')}</h2>
            <p>{t('about.subtitle')}</p>
            <p>{t('about.subtitle2')}</p>
            <p>{t('about.subtitle3')}</p>
          </div>
        </div>
      </Fade>
    </section>
  );
}

export default About;
